// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","CloseButton":"_2cIHsq","fadeInFrames":"_12Qr2w"};